import {
  Box,
  Checkbox,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { colorsEnums } from '../constants/enums';
import { MarginOutlined } from '@mui/icons-material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      boxShadow:
        '0px 0px 4px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: '4px',
      border: 'none',
      marginTop: 25,
    },
  },
};

export default function CustomMultiSelectInHome({
  options = [],
  value = [],
  onChange,
  placeholder = 'Select',
  iconComponent,
  labelSuffix = '',
  avoidSuffix = '',
  isLoading,
  errorMessage,
  error,
  fromHome = false,
  onOpen,
  onClose,
  ...props
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Box sx={{ width: '100%' }}>
      <Select
        multiple
        fullWidth
        size="small"
        open={dropdownOpen}
        onOpen={() => {
          setTimeout(() => setDropdownOpen(true), 300);
        }}
        onClose={() => setDropdownOpen(false)}
        displayEmpty
        sx={{
          boxShadow: 'none !important',
          border: 'none !important',
          width: '100%',
          minWidth: '100%',
          maxWidth: '100%',
          paddingLeft: 0,
          borderRadius: '8px',
          // height: '44px',
          fontSize: '14px',
          '& .MuiOutlinedInput-input': {
            padding: 0,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        value={value}
        onChange={onChange}
        input={
          <OutlinedInput
            sx={{
              border: 'none',

              '& .MuiOutlinedInput-input': {
                paddingLeft: 0,
              },
            }}
          />
        }
        renderValue={(selected) => {
          if (selected?.length === 0) {
            return <span style={{ color: '#aaa' }}>{placeholder}</span>;
          }
          return selected
            .map(
              (item) =>
                `${item}${
                  labelSuffix && item !== avoidSuffix ? ` ${labelSuffix}` : ''
                }`
            )
            .join(', ');
        }}
        MenuProps={MenuProps}
        inputProps={{ 'aria-label': 'Without label' }}
        IconComponent={iconComponent}
        loading={isLoading}
        {...props}
      >
        {isLoading ? (
          <MenuItem>Loading...</MenuItem>
        ) : (
          options.map((item) => (
            <MenuItem
              key={item?.value}
              value={item?.value}
              sx={{
                background: 'none !important',
                height: '40px',
                '&:hover': {
                  background: '#F2F3F5',
                },
              }}
            >
              <Checkbox
                sx={{ color: '#7C8694' }}
                checked={value?.includes(item?.value)}
              />
              <ListItemText
                sx={{
                  fontSize: '14px !important',
                  padding: '10px',
                  paddingLeft: 0,
                }}
                primary={item?.value}
              />
            </MenuItem>
          ))
        )}
      </Select>
      {errorMessage && (
        <Box sx={{ mt: '7px' }}>
          <Typography
            style={{
              color: colorsEnums.error,
              fontSize: '12px',
            }}
          >
            {errorMessage}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
